import Breadcrumb from "../components/Breadcrumb";
import { useLang } from "../lang";
import { SITE } from "../content";
import { LEGAL } from "../legal";

export default function LegalPage({ kind }) {
  const { lang } = useLang();
  const doc = LEGAL[kind][lang] || LEGAL[kind].it;
  const ctx = { company: SITE.fullName, address: `${SITE.headOffice.street}, ${SITE.headOffice.zip} ${SITE.headOffice.city} (${SITE.headOffice.province})`, email: SITE.email, vat: SITE.vat };
  const fill = (s) => s.replace(/\{(\w+)\}/g, (_, k) => ctx[k] ?? "");

  return (
    <main className="min-h-screen bg-white pt-20" data-testid={`legal-${kind}`}>
      <div className="max-w-[820px] mx-auto px-6 pt-8 pb-24">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: doc.title }]} />
        <h1 className="mt-10 text-4xl sm:text-5xl font-semibold tracking-[-0.02em] text-[#1d1d1f]">{doc.title}</h1>
        <p className="mt-4 text-[14px] text-[#6e6e73]">{doc.updated}</p>
        <div className="mt-12 space-y-10">
          {doc.sections.map((s) => (
            <section key={s.h}>
              <h2 className="text-[20px] md:text-[22px] font-semibold tracking-[-0.01em] text-[#1d1d1f]">{s.h}</h2>
              <div className="mt-3 space-y-3 text-[15px] md:text-[16px] leading-relaxed text-[#1d1d1f]/80">
                {s.p.map((t, i) => <p key={i}>{fill(t)}</p>)}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
